import type { ChangelogEntry } from "../types";

/** Møtebookeren kan legge til og rette kontaktpersoner på leadet den ringer. */
export const LEAD_KONTAKTER_2026_10: ChangelogEntry = {
  id: "2026-10-28-lead-kontakter",
  date: "2026-10-28",
  title: "Møtebookeren kan legge til og rette kontaktpersoner på leads",
  summary: "I Book møte på et lead kan også møtebookeren legge til en ny kontakt eller rette den valgte, for eksempel legge inn e-posten som mangler.",
  sections: [
    {
      heading: "Salgsmuligheter",
      minRole: "user",
      items: [
        {
          title: "Kontaktpersoner på leads",
          kind: "forbedret",
          featureFlag: "feature_crm_leads_moter",
          body: "«Ny kontaktperson» og «Rediger kontakt» i Book møte virker nå for alle som ringer leads, også møtebookere. Det gjelder leadet du har fått tildelt.",
        },
      ],
    },
  ],
};
